import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Hide header on admin routes
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  
  const navItems = [
    { name: 'Início', path: '/' },
    { name: 'Serviços', path: '/#servicos' },
    { name: 'Contato', path: '/#contato' },
  ];
  
  return (
    <motion.header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-xl bg-[#080710]/70 border-b border-[#22D3EE]/10' : ''
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="logo-link">
            <Logo size={36} showText={true} />
          </Link>
          
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.path}
                data-testid={`nav-${item.name.toLowerCase()}`}
                className="text-[#F8FAFC]/80 hover:text-[#22D3EE] transition-colors text-sm tracking-wide"
              >
                {item.name}
              </a>
            ))}
            <Link
              to="/orcamento"
              data-testid="cta-orcamento-header"
              className="relative bg-[#22D3EE] text-[#080710] px-6 py-2.5 rounded-md font-semibold text-sm tracking-wide hover:shadow-[0_0_24px_rgba(34,211,238,0.5)] transition-all"
            >
              Solicitar Orçamento
            </Link>
          </nav>
          
          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-[#F8FAFC]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            data-testid="mobile-menu"
            className="md:hidden mt-4 pb-4 space-y-4"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.path}
                className="block text-[#F8FAFC]/80 hover:text-[#22D3EE] transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </a>
            ))}
            <Link
              to="/orcamento"
              className="block bg-[#22D3EE] text-[#080710] px-6 py-2 rounded-md font-semibold text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Solicitar Orçamento
            </Link>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
}
